import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import AzureDevOpsCalc from '../components/calculators/AzureDevOpsCalc'

export default function AzureDevOpsPage() {
  return (
    <>
      <Helmet>
        <title>Azure DevOps Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure DevOps costs for UK teams. Parallel jobs, user licensing (Basic + Test Plans), artifact storage — all in GBP. Understand what a parallel job actually is before you buy more." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/azure-devops" />
        <meta property="og:title" content="Azure DevOps Cost Calculator UK" />
        <meta property="og:description" content="Parallel jobs, user licensing, artifact storage — Azure DevOps pricing in GBP. The first parallel job and 5 Basic users are free." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/azure-devops" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure DevOps Cost Calculator',
          description: 'Estimate Azure DevOps costs including parallel jobs, user licensing, and artifact storage for UK teams.',
          url: 'https://www.azure-calc.co.uk/azure-devops',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure DevOps Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK pricing · Parallel jobs · Users · Artifact storage · CI/CD pipelines
          </p>
        </div>

        <AzureDevOpsCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>
            Related guides
          </h2>
          <Link
            to="/guides/azure-devops-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold" style={{ color: 'var(--text-secondary)' }}>Azure DevOps Pricing Guide UK 2026</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>Parallel jobs explained, Microsoft-hosted vs self-hosted, user licensing, artifact storage</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
